import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const NitriteIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorBorder;
  return (
    <svg width="50px" height="44px" viewBox="0 0 50 44" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Assets-for-WWT" transform="translate(-315, -418)">
          <g id="Group-37" transform="translate(165, 394)">
            <g id="Group-5" transform="translate(150, 24)">
              <text id="NO" fontFamily="Heebo-ExtraBold, Heebo" fontSize="16" fontWeight="700" fill={currentColor}>
                <tspan x="9" y="28">
                  NO
                </tspan>
              </text>
              <text id="3" fontFamily="Heebo-ExtraBold, Heebo" fontSize="12" fontWeight="700" fill={currentColor}>
                <tspan x="32" y="32">
                  2
                </tspan>
              </text>
              <text id="-" fontFamily="Heebo-ExtraBold, Heebo" fontSize="12" fontWeight="700" fill={currentColor}>
                <tspan x="32" y="19">
                  -
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default NitriteIcon;
